// src/domains/legal.ts —— 法律页链接（06 U-01 登录 / 注册协议提示、U-20 S-60 Mini App 首开条幅共用）：
// 书名号段（en：Terms / Privacy Policy）渲染为 {site_url}/legal/{terms|privacy}?lang=（W-01b 路由约定）；
// site_url 来自 GET /public/config，只接受 https 源（防 javascript: / data: 等非网页协议注入 href，TD-852）
import { getTg } from '../../../shared/src/tg';
import type { ClickEvent } from './types';

export interface LegalPart {
  text: string;
  isLink: boolean;
  isText: boolean;
  href: string;
  open: (e: ClickEvent) => void;
}

// 仅 https:；返回规范化 origin + 路径前缀（去尾斜杠）。非法 / 非 https 返回空串（调用方按纯文本渲染，不出链接）
export function safeSiteUrl(raw: string): string {
  const v = raw.trim();
  if (!v) return '';
  let u: URL;
  try {
    u = new URL(v);
  } catch {
    console.warn('[gp:h5] site_url 非法，法律链接按纯文本渲染', v);
    return '';
  }
  if (u.protocol !== 'https:' || u.username || u.password) {
    console.warn('[gp:h5] site_url 非 https，法律链接按纯文本渲染', v);
    return '';
  }
  return (u.origin + u.pathname).replace(/\/+$/, '');
}

// TG 内经 WebApp.openLink 打开外链（06 U-01 / U-20）；shared TgWebApp 类型未声明 openLink，按运行期能力探测
export function openExternalLink(href: string): boolean {
  const tg = getTg();
  if (tg && 'openLink' in tg && typeof tg.openLink === 'function') {
    Reflect.apply(tg.openLink, tg, [href]);
    return true;
  }
  return false;
}

const LEGAL_RE = /(《用户协议》|《隐私政策》|\bTerms\b|\bPrivacy Policy\b)/;

export function legalParts(text: string, siteUrl: string, lang: 'zh' | 'en'): LegalPart[] {
  const site = safeSiteUrl(siteUrl);
  const noop = (): void => undefined;
  return text
    .split(LEGAL_RE)
    .filter((p) => p !== '')
    .map((p) => {
      const kind = !LEGAL_RE.test(p) ? '' : /用户协议|Terms/.test(p) ? 'terms' : 'privacy';
      const href = kind && site ? `${site}/legal/${kind}?lang=${lang}` : '';
      if (!href) return { text: p, isLink: false, isText: true, href: '', open: noop };
      return {
        text: p,
        isLink: true,
        isText: false,
        href,
        open: (e: ClickEvent) => {
          e.stopPropagation(); // 条款行整行可点（toggleTerms），点链接不改变勾选
          if (openExternalLink(href)) e.preventDefault();
        },
      };
    });
}
